import styles from "./SubscribeInfo.module.scss"

import React, { MouseEvent } from "react"

import { WOWNET_CONTENT } from "@shared/constants"
import { useLayerPopupContext, useSchedule } from "@shared/contexts"

function SubscribeInfo() {
  const { close } = useLayerPopupContext()
  const { schedule } = useSchedule()
  const streamerUsername = schedule?.user.username

  return (
    <React.Fragment>
      <article
        className="popup"
        style={{ width: 350, margin: "-160px 0 0 -175px" }}
      >
        <div className="titB">
          <h1>알림</h1>
          <a
            href="#!"
            title="닫기"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <div className="roundB">
            <p>
              상품 가입 이후에
              <br />
              확인하실 수 있습니다.
            </p>
          </div>
        </div>
        <div className="btnB">
          <a
            href="#!"
            title="가입 상품 보기"
            className={styles.wide}
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              window.open(
                `${WOWNET_CONTENT.link}/?type=INFO&analid=${streamerUsername}`,
                "buyLink",
              )
              close()
            }}
          >
            가입 상품 보기
          </a>
        </div>
      </article>
    </React.Fragment>
  )
}

export default SubscribeInfo
